import React from 'react';
import Sidebar from '../components/Sidebar';
import TaskBundles from '../components/TaskBundles';

const BundlesPage = () => {
  return (
    <Sidebar>
      <div className="min-h-screen">
        {/* Header */}
        <header className="sticky top-0 z-20 bg-background/80 backdrop-blur-lg border-b">
          <div className="px-4 sm:px-6 py-3 sm:py-4 pl-14 lg:pl-6">
            <h1 className="font-heading text-xl sm:text-2xl font-bold">Task Bundles</h1>
            <p className="text-xs sm:text-sm text-muted-foreground">
              Group related tasks with ordering and dependencies
            </p>
          </div>
        </header>

        {/* Main Content */}
        <main className="p-4 sm:p-6">
          <TaskBundles />
        </main>
      </div>
    </Sidebar>
  );
};

export default BundlesPage;
